import { render, staticRenderFns } from "./DashboardStoryboardsCategories.vue?vue&type=template&id=0573b5bb&scoped=true&"
import script from "./DashboardStoryboardsCategories.vue?vue&type=script&lang=js&"
export * from "./DashboardStoryboardsCategories.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStoryboardsCategories.vue?vue&type=style&index=0&id=0573b5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573b5bb",
  null
  
)

export default component.exports